jQuery(function () {
    var scrollTop = 0;
    var menuOpen = false;
    $('.js-navigation-hamburger').on('click', function (evt) {
        menuOpen = !menuOpen;
        $(evt.target).closest('.js-navigation-hamburger').toggleClass('is-active');
        $('.navigation-bar').toggleClass('mobile-menu-open');
        stopBodyScroll(menuOpen);
        if ($('.renovation-phases.is-active').length > 0) {
            $('.renovation-phases, .renovation-phases__column__container').removeClass('is-active');
        }
    });
    $('.contextual-menu__icon').on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        $('.contextual-menu.open').removeClass('open');
        var contextualMenu = $(evt.target).closest('.contextual-menu');
        contextualMenu.toggleClass('open');
        $(document.body).one('click', function () { return contextualMenu.removeClass('open'); });
    });
    $('.ts-hamburger-user-btn').on('click', function () {
        $(this).toggleClass('is-active');
        $('.ts-hamburger-user-links').slideToggle();
    });
    $('.ts-hamburger-houses-btn').on('click', function () {
        if ($(this).hasClass('one-house')) {
            return;
        }
        $(this).toggleClass('is-active');
        $('.ts-hamburger-houses-select').slideToggle();
    });
    function stopBodyScroll(stop) {
        var $body = $('body');
        if (stop) {
            scrollTop = $body.scrollTop();
            $body.addClass('prevent-mobile-scroll');
        }
        else {
            $body.removeClass('prevent-mobile-scroll');
            $body.scrollTop(scrollTop);
        }
    }
});
jQuery(function () {
    $('.ts-dropdown-btn').on('click', function (evt) {
        if ($(evt.target).hasClass('one-house')) {
            return;
        }
        var dropdown = $(evt.target).closest('.ts-dropdown-btn');
        var dropdownArea = dropdown.next('.ts-menu-dropdown-area');
        if (dropdown.hasClass('is-active')) {
            dropdown.toggleClass('is-active');
            dropdownArea.fadeToggle();
        }
        else {
            $('.ts-dropdown-btn').removeClass('is-active');
            $('.ts-menu-dropdown-area').fadeOut();
            dropdown.toggleClass('is-active');
            dropdownArea.fadeToggle();
        }
    });
    $('body').on('click', function (evt) {
        var link = $(evt.target).closest('a');
        var dropdown = $('.ts-dropdown-btn');
        if (!link.hasClass('ts-dropdown-btn') && !link.hasClass('ts-dropdown-btn-link')) {
            dropdown.removeClass('is-active');
            $('.ts-menu-dropdown-area').fadeOut();
        }
    });
    $(document).ready(function () {
        $(window).scroll(function () {
            var dropdown = $('.ts-dropdown-btn');
            if (dropdown.hasClass('is-active')) {
                dropdown.removeClass('is-active');
                $('.ts-menu-dropdown-area').fadeOut();
            }
        });
    });
    $(document).ready(function () {
        var dropdown = $('.ts-menu-dropdown-area');
        var isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
        if (isIE) {
            dropdownPositioning();
            $(window).resize(function (e) {
                dropdownPositioning();
            });
        }
        function dropdownPositioning() {
            if (dropdown.length > 0) {
                var windowWidth = window.innerWidth;
                var navigationWidth = $('.navigation-bar__body').width();
                var dropdownMargin = parseInt(dropdown.css('margin-left').replace(/[^-\d.]/g, ''));
                var dropdownPosRight = (windowWidth - navigationWidth) / 2 - dropdownMargin - 8;
                dropdown.css('right', dropdownPosRight);
            }
        }
    });
});
function objectFitVideos() { } /*eslint-disable-line*/
function objectFitImages() { } /*eslint-disable-line*/
jQuery(function () {
    if (!isKnownGoodBrowser()) {
        objectFitVideos();
        objectFitImages();
    }
    function isKnownGoodBrowser() {
        return ((navigator.userAgent.indexOf('Safari') > -1 ||
            navigator.userAgent.indexOf('Chrome') > -1) || navigator.userAgent.indexOf('Firefox') > -1 &&
            !/Edge/.test(navigator.userAgent));
    }
});
